import type { ProgramUserRsvp } from 'models';
import { type ReactNode, useCallback } from 'react';
import { Icon, type TagColor } from 'ui';
import { useEventRsvpLabels } from '../../../hooks';

export const useGetPastEventStatusInformation = () => {
  const { getPastStatusLabel } = useEventRsvpLabels();

  return useCallback(
    ({ status }: { status?: ProgramUserRsvp }): { color?: TagColor; icon?: ReactNode; text: string } => {
      switch (status) {
        case 'going':
          return {
            color: 'success',
            icon: <Icon icon="check-circle-fill" />,
            text: getPastStatusLabel({ rsvp: 'going' }),
          };
        case 'not_going':
        case undefined:
          return {
            color: 'error',
            icon: <Icon icon="close-circle-fill" />,
            text: getPastStatusLabel({ rsvp: 'not_going' }),
          };
        case 'pending':
          return { text: getPastStatusLabel({ rsvp: 'pending' }) };
      }
    },
    [getPastStatusLabel],
  );
};
